import { client, handleRequest, handleRequestBody } from "./client.ts";

export type HolidaySource = "national" | "manual";

export interface Holiday {
	id: string;
	date: string;
	name: string;
	source: HolidaySource;
	created_by_user_id: string | null;
	created_at: string;
}

export interface HolidaysResponse {
	year: number;
	count: number;
	items: Holiday[];
}

export function listHolidays(
	worksiteId: string,
	year: number,
): Promise<HolidaysResponse> {
	return handleRequestBody(() =>
		client.get<HolidaysResponse>(`/worksites/${worksiteId}/holidays`, {
			params: { year },
		}),
	);
}

export interface CreateHolidayInput {
	date: string;
	name: string;
}

interface HolidayResponse {
	holiday: Holiday;
}

export async function createHoliday(
	worksiteId: string,
	input: CreateHolidayInput,
): Promise<Holiday> {
	const { holiday } = await handleRequestBody(() =>
		client.post<HolidayResponse>(`/worksites/${worksiteId}/holidays`, input),
	);
	return holiday;
}

export async function deleteHoliday(
	worksiteId: string,
	holidayId: string,
): Promise<void> {
	await handleRequest(() =>
		client.delete(`/worksites/${worksiteId}/holidays/${holidayId}`),
	);
}

export function importNationalHolidays(
	worksiteId: string,
	year: number,
): Promise<HolidaysResponse> {
	return handleRequestBody(() =>
		client.post<HolidaysResponse>(
			`/worksites/${worksiteId}/holidays/import`,
			undefined,
			{ params: { year } },
		),
	);
}
